<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/10/2021
  -->

<template>
	<qw-dropdown
		:options="options"
		v-bind="$attrs">
		<template #trigger>
			<slot name="trigger">
				<qw-button v-bind="buttonAttrs">
					<slot>{{ buttonText }}</slot>
					<slot name="icon"><i class="fontello icon-angle-down ml-1 font-size-4"/></slot>
				</qw-button>
			</slot>
		</template>
	</qw-dropdown>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import QwDropdown from "@/core/components/Controls/Buttons/QwDropdown.vue";

export default {
	name: "QwDropdownButton",
	components: {QwDropdown},
	extends: BaseComponent,
	// inheritAttrs: false,
	props: {
		buttonText: {String, default: "Click"},
		options: {Array, required: true},
	},

	computed: {
		buttonAttrs() {
			let attrs = {}
			Object.keys(this.$attrs).forEach(key => {
				if(key.startsWith("button-")){
					let buttonKey = key.replace("button-", "")
					attrs[buttonKey] = this.$attrs[key]
				}
			})
			return attrs
		}
	},
}
</script>

<style lang="scss">

</style>
